import React, { Component } from "react";
import _ from "lodash";

class TableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  createKey = (item, column) => {
    return item + (column.path || column.key);
  };

  render() {
    const { data, columns } = this.props;
    let index = 0;
    return (
      <tbody>
        {data.map(item => (
          <tr key={++index}>
            {columns.map(column => (
              <td key={this.createKey(item.id ? item : index, column)}>
                {this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default TableBody;
